import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-header-funnel',
  templateUrl: './header-funnel.component.html',
  styleUrls: ['../navbar.component.scss','./header-funnel.component.scss']
})
export class HeaderFunnelComponent implements OnInit{
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document) { }
  public fixNavBar: boolean = false;
  protected navbar = this.document.getElementById("navbar");
  protected sticky = this.navbar?.offsetTop;
  public navigation_links = [
    {
      name: $localize`CONSULTA GRATUITA`,
      path: 'https://my.bhavani.app/en/microdosing/?offer=get-10-minutes-free',
      external: true,
      routeData:{showMainNavBar:false}
    },{
      name: $localize`Sobre Nosotros`,
      path: '/about-us',
      external: false,
      routeData:{showMainNavBar:false}
    },
    {
      name: $localize`Protocolo`,
      path: '/protocol-coaching-1',
      external: false,
      routeData:{showMainNavBar:false}
    },
    {
      name: $localize`Nuestro Enfoque`,
      path: '/our-approach',
      external: false,
      routeData:{showMainNavBar:false}
    }
  ];

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.stickyNavbar();
    }
  }
  @HostListener('window:scroll',['$event'])
  stickyNavbar() {
    let navbar = this.navbar;
    let sticky = this.sticky;
    if (!navbar||!sticky) return;
    isPlatformBrowser(this.platformId)&&window.scrollY >= sticky?this.fixNavBar = true:this.fixNavBar = false;
  }
  }

